export default __webpack_public_path__ + "static/media/arrows-hv.4ec648be.svg";